module.exports = __webpack_public_path__ + "img/calendar.b9478507.svg";